import { Component, inject, signal } from '@angular/core';
import { CreateSparkCampaign } from '../../../../service/create-spark-campaign/create-spark-campaign';

@Component({
  selector: 'cad-ad-preview',
  imports: [],
  templateUrl: './ad-preview.html',
  styleUrl: './ad-preview.css',
})
export class AdPreview {

  /** Services */
  public createSparkCampaignService = inject(CreateSparkCampaign);
  /** Services - END */

  hasStartedVideo = signal(false);
  isVideoPlaying = signal(false);
  isVideoHovered = signal(false);

  getCTAButtonText() {
    return "TO-DO - Text"
  }

  getIdentityTypeText() {
    if (this.createSparkCampaignService.selectedCreative()) {
      return `@${this.createSparkCampaignService.selectedCreative()!.creator_info.display_name}`;
    } else {
      return 'Your identity';
    }
  }

  setVideoHovered(hovered: boolean): void {
    this.isVideoHovered.set(hovered);
  }

  onVideoPlay(): void {
    this.isVideoPlaying.set(true);
    this.hasStartedVideo.set(true);
  }

  onVideoPause(): void {
    this.isVideoPlaying.set(false);
  }

  async toggleVideoPlayback(video: HTMLVideoElement): Promise<void> {
    if (video.paused) {
      this.hasStartedVideo.set(true);
      await video.play();
      return;
    }
    video.pause();
  }
}
